import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "list-wrap" }
const _hoisted_2 = { class: "main-wrap" }
const _hoisted_3 = { class: "head" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 1,
  class: "search"
}
const _hoisted_6 = { class: "head" }
const _hoisted_7 = {
  key: 0,
  class: "emoty-wrap"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  class: "empty",
  src: "https://xiamenban.oss-cn-hangzhou.aliyuncs.com/official/empty.png",
  alt: ""
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", null, "该栏目下暂无数据", -1)
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = {
  key: 0,
  class: "paging"
}

import { ref, reactive, watch } from "vue";
import { ElPagination, ElEmpty } from "element-plus";
import myheader from "@/components/pcComp/header1";
import newItem from "@/components/pcComp/newItem";
import footerCom from "@/components/pcComp/footerCom";
import { getColumnList, getArticleQuery } from "../../request/api";
import { useRoute, useRouter } from "vue-router";
import { ElLoading } from "element-plus";
import "element-plus/theme-chalk/el-loading.css";


// let  a=document.getElementsByClassName("is-active")
// console.log(a,"aaaaaaa")
// a.style.color="#bd1a2d"

export default /*#__PURE__*/_defineComponent({
  __name: 'newList',
  setup(__props) {

let currentNav: number = ref(0);

const changeNav = (index: number) => {
  console.log(currentMenu.value.children[index], "qweqweq");
  if (currentMenu.value.children[index].link_url) {
    window.open(currentMenu.value.children[index].link_url);
  } else {
    currentNav.value = index;
    params.value.pageNum = 1;
    params.value.column_id =
      currentMenu.value.children[currentNav.value].id == 8
        ? null
        : currentMenu.value.children[currentNav.value].id;
    getArticleList();
  }
};
let params = ref({
  column_id: null,
  pageNum: 1,
  pageSize: 10,
  title: ""
});
// column_id: currentMenu.value.children[currentNav.value].id,
const route = useRoute();
const router = useRouter();
// debugger
// 获取父级id
params.value.title = router.currentRoute._value.query.keyWord || "";
// if(params.value.title){

// }
console.log(params.value.title, "params.value.title66666");
let pid = router.currentRoute._value.query.level1Id || null;
let id = router.currentRoute._value.query.level2Id || null;
let total = ref(0);
let articleList = ref([]);
// 获取文章列表
let getArticleList = () => {
  const loading = ElLoading.service({
    lock: true,
    text: "Loading",
    background: "rgba(0, 0, 0, 0.1)"
  });
  getArticleQuery(params.value).then(res => {
    console.log(res.data.data, 7777);
    // if(params.value.title){
    articleList.value = res.data.data.map(val => {
      val.title = val.title.replaceAll(
        params.value.title,
        `<span style='color:red'>${params.value.title}</span>`
      );
      if (val.abstract.indexOf(params.value.title) != -1) {
        let i = null;
        i = val.abstract.indexOf(params.value.title);
        val.abstract = val.abstract.substr(i, 50);
        val.abstract = val.abstract.replaceAll(
          params.value.title,
          `<span style='color:red'>${params.value.title}</span>`
        );
      } else if (val.content.content.indexOf(params.value.title) != -1) {
        // let i = null;
        // i = val.content.content.indexOf(params.value.title);
        val.abstract = val.content.content.substr(0, 50);
        val.abstract = val.abstract.replaceAll(
          params.value.title,
          `<span style='color:red'>${params.value.title}</span>`
        );
      }

      return {
        ...val
      };
    });
    loading.close();
    total.value = res.data.total;
    console.log(articleList.value, "articleList.valuearticleList.value");
  });
};
// 获取栏目共所有新闻组件使用
const navList: Array<any> = ref([]);
let currentMenu = ref([]);
// 获取栏目
let getColumnData = () => {
  getColumnList({}).then(res => {
    if (res.data.code == 200) {
      navList.value = res.data.data;
      if (!params.value.title) {
        // 获取当前菜单以及子菜单
        navList.value.forEach(val => {
          if (val.id == pid) {
            currentMenu.value = val;
            // 如果是由二级菜单跳转过来的
            if (id) {
              val.children.forEach((subVal, subIndex) => {
                if (id == subVal.id) {
                  currentNav.value = subIndex;
                }
              });
            }
            console.log(currentMenu.value, "currentMenu");
          }
        });

        params.value.column_id =
          currentMenu.value?.children[currentNav.value]?.id || pid;
        // 排除厦办动态
        params.value.column_id =
          params.value.column_id == 8 ? null : params.value.column_id;
      }
      getArticleList();
      console.log(navList.value, "navList.value1111111113333");
    }
  });
};
getColumnData();

// 监控路由变化来获取数据
watch(
  () => route.params,
  (newVal, oldVal) => {
    params.value.title = router.currentRoute._value.query.keyWord || "";
    pid = router.currentRoute._value.query.level1Id || null;
    id = router.currentRoute._value.query.level2Id || null;
    params.value.column_id = id || pid;
    params.value.column_id =
      params.value.column_id == 8 ? null : params.value.column_id;
    params.value.pageNum = 1;
    if (!params.value.title) {
      navList.value.forEach(val => {
        if (val.id == pid) {
          currentMenu.value = val;
          // 如果是由二级菜单跳转过来的
          if (id) {
            val.children.forEach((subVal, subIndex) => {
              if (id == subVal.id) {
                currentNav.value = subIndex;
              }
            });
          }
          console.log(currentMenu.value, "currentMenu");
        }
      });
    }

    console.log(pid, id, "watching");
    getArticleList();
  }
);

// 分页相关
const handleSizeChange = (val: number) => {
  console.log(`${val} items per page`);
  params.value.pageSize = val;
  getArticleList();
};
const handleCurrentChange = (val: number) => {
  console.log(`current page: ${val}`);
  params.value.pageNum = val;
  getArticleList();
};

let articleDetail = item => {
  console.log(item, "id");
  if (item.link_url) {
    let url =
      item.link_url.substr(0, 4) == "http"
        ? item.link_url
        : "http://" + item.link_url;
    window.open(url);
  } else {
    router.push({
      path: "/pages/detail/detail",
      query: {
        id: item.id,
        level1Id: item.column.parent_id,
        level2Id: item.column_id,
        keyWord: params.value.title
      }
    });
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(myheader)),
    _createElementVNode("div", _hoisted_2, [
      (!_unref(params).title)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["nav-side", _unref(currentMenu).children.length?'childs':''])
          }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(currentMenu).name), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currentMenu).children, (item, index) => {
              return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["nav-item",  _unref(currentNav)==index?'active':'']),
                key: index,
                onClick: ($event: any) => (changeNav(index))
              }, _toDisplayString(item.name), 11, _hoisted_4))
            }), 128))
          ], 2))
        : _createCommentVNode("", true),
      (_unref(params).title)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, "共搜索到" + _toDisplayString(_unref(total)) + "条结果", 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["news-list", !_unref(articleList).length?'hide':''])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(articleList), (item, index) => {
          return (_openBlock(), _createBlock(_unref(newItem), {
            key: index,
            article: item,
            onClick: ($event: any) => (_unref(articleDetail)(item))
          }, null, 8, ["article", "onClick"]))
        }), 128)),
        (!_unref(articleList).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_10))
          : _createCommentVNode("", true)
      ], 2)
    ]),
    (_unref(articleList).length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_unref(ElPagination), {
            small: "",
            layout: "prev, pager, next",
            total: _unref(total),
            onSizeChange: handleSizeChange,
            onCurrentChange: handleCurrentChange
          }, null, 8, ["total"])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_unref(footerCom), { style: {"margin-top":"60px"} })
  ]))
}
}

})